<app-header></app-header>

<ion-content class="ion-no-padding" *ngIf="page">
  <!-- sekcja MOJE REZERWACJE -->
  <app-space-reservations
    *ngIf="page === 'desk_my_reservations'"
    [spaceType]="spaceType"
  ></app-space-reservations>

  <!-- sekcja WSZYSTKIE REZEWACJE PARKINGOWE -->
  <app-space-reservations
    *ngIf="page === 'desk_all_reservations'"
    [showAllReservations]="'true'"
    [spaceType]="spaceType"
  ></app-space-reservations>

  <app-space-list
    *ngIf="page === 'desk_space'"
    routerLinkBase="/app/desk/parking-space/"
    addLink="/app/desk/add-desk/"
    spaceAddRole="desk.spaces.add-edit"
    addButtonLabel="SPACE.DESK.ADD_DESK"
    [spaceType]="spaceType"
    [withAssignment]="true"
  ></app-space-list>
</ion-content>
